var map = {
	"./logo-01-bnb.png": 243,
	"./logo-02-barcelo.png": 244,
	"./logo-03-ringhotels.png": 245,
	"./logo-04-iberostar-group.png": 246,
	"./logo-05-amresorts.png": 247,
	"./logo-06-kempinski.png": 248,
	"./logo-07-grecotel-group.jpg": 249,
	"./logo-08-achat-hotels.png": 250,
	"./logo-09-falkensteiner-hotels.png": 251,
	"./logo-10-bluebayhotels.png": 252,
	"./logo-11-rixos-hotel.png": 253,
	"./logo-12-lapland-hotels.png": 254,
	"./logo-13-adiwana-hotels.png": 255,
	"./logo-14-corendon-hotels-resorts.png": 256,
	"./logo-15-esperia-group.jpg": 257,
	"./logo-16-zafiro.png": 258,
	"./logo-17-ax-hotels.png": 259,
	"./logo-18-hoteles-poseidon.png": 260,
	"./logo-19-hotels-viva.png": 261,
	"./logo-20-bluegr.png": 262,
	"./logo-21-hcc-hotels.png": 263,
	"./logo-22-kapama.png": 264,
	"./logo-23-voyage.png": 265,
	"./logo-24-ic-hotels.png": 266,
	"./logo-25-pure-salt.png": 267,
	"./logo-26-landmar-hotels.png": 268,
	"./logo-27-agape-hotel.jpg": 269,
	"./logo-28-delita-hotels.jpg": 270,
	"./logo-29-inspiravacation.png": 271,
	"./logo-30-lidos-hotels.jpg": 272,
	"./logo-31-mac-hotels.png": 273,
	"./logo-33-pilot-beach-resort.jpg": 274,
	"./logo-35-regnum-carya.jpg": 275,
	"./logo-36-zum-freigericht.jpg": 276
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 242;